import repair_loco from "../../images/gameplay_ui/illustrations/repair_loco.png";
import repair_electro from "../../images/gameplay_ui/illustrations/repair_electro.png";
import repair_infra from "../../images/gameplay_ui/illustrations/repair_infra.png";
import repair_loco_icon_parts from "../../images/gameplay_ui/icons/repair/loco_icon.svg";
import repair_electro_icon_parts from "../../images/gameplay_ui/icons/repair/electro_icon.svg";
import repair_infra_icon_parts from "../../images/gameplay_ui/icons/repair/infra_icon.svg";

export const STATION_HEADER_COLORS = [
    ["#6792DA", "#274C90"], //anino
    ["#00FFE9", "#00B2A3"], //krosh
    ["#FE5419", "#FF0000"], //arhi
    ["#FFF101", "#FFCD00"] //stup
]
export const CARGO_HEADER_COLORS = (type)=>
{
    let defData = {
        "coal": ["#AEAEAE", "#3C3C3C"],
        "prod": ["#FFF35E", "#F89F03"],
        "containerWithCargo": ["#5584BF", "#1B4C8D"],
        "containerEmpty": ["#B3D4FF", "#5482C1"],
        "cement": ["#D2D7DA", "#A3A5A4"],
        "empty": ["#C58A82", "#7E3D36"]
    }
    if(type in defData){
        return defData[type];
    }

    return CLIENT_COLORS["other"]
}
export const CLIENT_COLORS = {
    "rc": CARGO_HEADER_COLORS("coal"),
    "ap": CARGO_HEADER_COLORS("prod"),
    "av": CARGO_HEADER_COLORS("containerWithCargo"),
    "bt": CARGO_HEADER_COLORS("cement"),
    "other": ["#C58A82", "#7E3D36"]
}
export const LOCO_HEADER_COLOR = {
    "loco": ["#57DFFF", "#017DAC"],
    "electro": ["#FDC347", "#FF9200"],
    "infra": ["#8CED00", "#66AE04"]
}
export const REPAIR_COLOR = [
    LOCO_HEADER_COLOR["electro"],
    LOCO_HEADER_COLOR["loco"],
    LOCO_HEADER_COLOR["infra"]
]
export const REPAIR_SHOPS_IMAGES = {
    "loco": repair_loco,
    "electro": repair_electro,
    "infra": repair_infra
}
export const REPAIR_SHOPS_ICONS = {
    "loco": repair_loco_icon_parts,
    "electro": repair_electro_icon_parts,
    "infra": repair_infra_icon_parts
}
export const REPAIR_STAGE_COLORS = [
    "rgba(3, 3, 3, 0.3)",
    "rgba(238, 49, 36, 0.5)",
    "rgba(253, 205, 8, 0.5)",
    "rgba(37, 159, 98, 0.5)",
]
export const DISPETCHER_COLOR = ["#FF30F7", "#A719FE"];
export const SECURITY_COLOR = ["#B3D4FF", "#5482C1"];

export const GetColorByTypeAndID = (type, id) => {
    switch (type) {
        case "dispetcher":
            return DISPETCHER_COLOR;
        case "station":
            return STATION_HEADER_COLORS[id];
        case "repair":
            return REPAIR_COLOR[id];
        default:
            return null;
    }
}
export const PROBLEM_COLORS = ["#EE3124", "#EE3124"]
export const RED_GRADIENT = ["#FE5419", "#FF0000"];
export const GREEN_GRADIENT = ["#8CED00", "#66AE04"];
export const UserGameViewSize = {width: window.innerWidth - 60, height: window.innerHeight - 60}

export const PATH_CARD_POSITIONS = [
    {x: 440, y: 370},
    {x: 680, y: 420},
    {x: 590, y: 160},
    {x: 780, y: 160},
    {x: 900, y: 340},
    {x: 1320, y: 390},
    {x: 1100, y: 280}
]
